<template>
    <div>
        <div v-if="contentType==1">
                <iframe width="100%" height="180" :src="content.topicFiles[0].file.file_path" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
        <div v-if="contentType==2">
         <audio width="300" height="150" controls>
            <source :src="content.topicFiles[0].file.file_path">
        </audio>
        </div> 
        <div v-if="contentType==5">
         <pdf :src="content.topicFiles[0].file.file_path"></pdf>
        </div>
    </div>
</template>
<script>
import pdf from 'vue-pdf'
export default {
  components: {
    pdf
  },
  props:{
    isTopicDetailsView:{
      default:false
    },
    contentType:{
      default:0
    },
    content:{
      default:null
    }
  }
}
</script>